module.exports = __webpack_public_path__ + "img/9791158886325.848437ad.jpg";